import { createFileRoute } from "@tanstack/react-router";
import { SignatureLogs } from "@/components/SignatureLogs";

function RouteComponent() {
  return <SignatureLogs />;
}

export const Route = createFileRoute("/_authenticated/signature-logs/")({
  component: RouteComponent,
  staticData: { page: "analytics" },
});
